import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { format } from "date-fns";
import { ConfigService } from "../services/config.service";

@Component({
    selector: "app-footer-bar",
    templateUrl: "./footer-bar.component.html",
    styleUrls: ["./footer-bar.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterBarComponent {
  @Input() hideBrandingText = false;
  thisYear = format(new Date(), "yyyy");
  version = this.configService.version;

  constructor(private configService: ConfigService) {}
}
